import taxStatusEnum from '@constants/enums/taxStatus';

import i18n from '@plugins/i18n';

import { HoldingCollection } from '@/models';

export class HoldingSingleCompanyPanelCollection extends HoldingCollection {
    static type = 'HoldingSingleCompanyPanelCollection';

    static fields() {
        return {
            ...super.fields(),
            company_id: this.string(null).nullable(),
            status: this.string('OPEN').nullable()
        };
    }

    get headers() {
        let headers = [
            // this.createHeader('gi_ref', i18n.t('gi_ref'), {
            //     filterable: true,
            //     width: '9rem'
            // }),
            // https://growthinvest.atlassian.net/browse/CORE-878
            // this.createHeader('investor_name', i18n.tc('investor'), {
            //     path: 'investor.name',
            //     width: '15rem',
            //     minWidth: '15rem'
            // }),
            this.createHeader('name', i18n.t('name'), {
                width: '18rem',
                minWidth: '18rem'
            }),
            this.createHeader('share_class', i18n.t('share_class'), {
                width: '8rem'
            }),
            this.createHeader('tax_status', i18n.t('tax_status'), {
                format: 'enum',
                filterable: true,
                enum: taxStatusEnum,
                enumA11yKey: 'enums.tax_status_short',
                formatOptions: {
                    tooltip: v => i18n.t(`enums.tax_status.${v}`)
                },
                width: '7rem',
                sortable: false
            }),
            this.createHeader('invested_amount', i18n.t('invested_amount'), {
                format: 'money',
                formatOptions: super.money_format_options,
                width: '8rem',
                fallback: data => {
                    if (data.item.pending_allotment) {
                        return i18n.t('pending');
                    }

                    return '-';
                }
            }),
            this.createHeader('tax_relief', i18n.t('tax_relief'), {
                format: 'money',
                formatOptions: super.money_format_options,
                width: '8rem'
            }),
            this.createHeader('share_quantity', i18n.t('share_quantity'), {
                format: 'number',
                width: '8rem'
            }),
            this.createHeader('share_issue_price', i18n.t('share_issue_price'), {
                format: 'money',
                formatOptions: super.money_format_options,
                width: '8rem',
                sortable: false
            }),
            this.createHeader('share_issue_on', i18n.t('share_issue_on'), {
                format: 'date',
                width: '8rem',
                fallback: data => {
                    if (data.item.pending_allotment) {
                        return i18n.t('pending');
                    }

                    return '-';
                }
            }),
            this.createHeader('application_on', i18n.t('application_on'), {
                format: 'date',
                width: '8rem'
            }),
            this.createHeader('tax_year', i18n.t('tax_year'), {
                width: '6rem',
                transform: data => this.getTaxYear(data.item.tax_year, { abbreviate: true }),
                fallback: data => {
                    if (data.item.pending_allotment) {
                        return i18n.t('pending');
                    }

                    return '-';
                }
            }),

            // this.createHeader('current_value_moic', i18n.t('current_value_moic'), {
            //     format: 'number',
            //     formatOptions: {
            //         minimumFractionDigits: 2,
            //         maximumFractionDigits: 2
            //     },
            //     append: 'X',
            //     width: '8rem',
            //     sortable: false
            // }),

            this.createHeader('current_share_price', i18n.t('current_share_price'), {
                column: 'current_share_price',
                format: 'money',
                formatOptions: super.money_format_options,
                width: '8rem',
                sortable: false
            }),

            this.createHeader('current_value', i18n.t('current_value'), {
                column: 'current_value',
                format: 'money',
                formatOptions: this.money_format_options,
                width: '9rem',
                sortable: false
            }),

            this.createHeader('total_return', i18n.t('total_return'), {
                column: 'total_return',
                format: 'money',
                formatOptions: this.money_format_options,
                width: '9rem',
                sortable: false
            }),

            this.createHeader('total_return_moic', i18n.t('total_return_moic'), {
                column: 'total_return_moic',
                format: 'number',
                formatOptions: {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                },
                append: 'X',
                width: '9.2rem',
                sortable: false
            }),

            // this.createHeader('total_return_irr', i18n.t('total_return_irr'), {
            //     column: 'total_return_irr',
            //     format: 'percentage',
            //     formatOptions: this.percentage_format_options,
            //     width: '8rem',
            //     sortable: false
            // }),

            this.createHeader('total_return_percentage', i18n.t('total_return_percentage'), {
                column: 'total_return_percentage',
                format: 'percentage',
                formatOptions: this.percentage_format_options,
                width: '9.2rem',
                sortable: false
            }),

            // this.createHeader('total_return_profit_loss', i18n.t('total_return_profit_loss'), {
            //     column: 'total_return_profit_loss',
            //     format: 'money',
            //     formatOptions: this.money_format_options,
            //     width: '9.2rem',
            //     sortable: false
            // }),

            this.createHeader('total_return_including_tax_relief', i18n.t('total_return_including_tax_relief'), {
                column: 'total_return_including_tax_relief',
                format: 'money',
                formatOptions: this.money_format_options,
                width: '9.2rem',
                sortable: false
            }),

            this.createHeader(
                'total_return_including_tax_relief_moic',
                i18n.t('total_return_including_tax_relief_moic'),
                {
                    column: 'total_return_including_tax_relief_moic',
                    format: 'number',
                    formatOptions: {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    },
                    append: 'X',
                    width: '11rem',
                    sortable: false
                }
            ),

            // this.createHeader(
            //     'total_return_including_tax_relief_irr',
            //     i18n.t('total_return_including_tax_relief_irr'),
            //     {
            //         column: 'total_return_including_tax_relief_irr',
            //         format: 'percentage',
            //         formatOptions: this.percentage_format_options,
            //         width: '11rem',
            //         sortable: false
            //     }
            // ),

            this.createHeader(
                'total_return_including_tax_relief_percentage',
                i18n.t('total_return_including_tax_relief_percentage'),
                {
                    column: 'total_return_including_tax_relief_percentage',
                    format: 'percentage',
                    formatOptions: this.percentage_format_options,
                    width: '10.2rem',
                    sortable: false
                }
            ),

            // this.createHeader(
            //     'total_return_profit_loss_including_tax_relief',
            //     i18n.t('total_return_profit_loss_including_tax_relief'),
            //     {
            //         column: 'total_return_profit_loss_including_tax_relief',
            //         format: 'money',
            //         formatOptions: this.money_format_options,
            //         width: '14rem',
            //         sortable: false
            //     }
            // ),

            // this.createHeader('total_return_with_exits', i18n.t('total_return_with_exits'), {
            //     column: 'total_return_with_exits',
            //     format: 'money',
            //     formatOptions: this.money_format_options,
            //     width: '11rem',
            //     sortable: false
            // }),

            // this.createHeader('distributions', i18n.t('distributions'), {
            //     format: 'money',
            //     formatOptions: super.money_format_options,
            //     width: '10rem',
            //     sortable: false
            // }),
            this.createHeader('reconciled', i18n.t('verified'), {
                filterable: true,
                format: 'boolean',
                width: '9rem',
                sortable: false
            })
        ];
        return headers;
    }

    get default_headers() {
        return [
            'name',
            'share_class',
            'tax_status',
            'invested_amount',
            'tax_relief',
            'share_quantity',
            'share_issue_price',
            'share_issue_on',
            'tax_year',
            'distributions',
            'current_share_price',
            'current_value',
            'total_return',
            'total_return_moic',
            'total_return_percentage',
            'total_return_including_tax_relief',
            'total_return_including_tax_relief_moic',
            'total_return_including_tax_relief_percentage'
        ];
    }

    get pdf_headers() {
        return [
            'name',
            'tax_status',
            'invested_amount',
            'tax_relief',
            'share_quantity',
            'share_issue_price',
            'share_issue_on',
            'tax_year',
            'current_share_price',
            'current_value',
            'total_return',
            'total_return_percentage',
            'total_return_including_tax_relief',
            'total_return_including_tax_relief_percentage'
        ];
    }

    get xlsx_headers() {
        return [
            'name',
            'share_class',
            'tax_status',
            'invested_amount',
            'tax_relief',
            'share_quantity',
            'share_issue_price',
            'share_issue_on',
            'application_on',
            'tax_year',
            'current_share_price',
            'current_value',
            'total_return',
            'total_return_moic',
            'total_return_percentage',
            'total_return_including_tax_relief',
            'total_return_including_tax_relief_moic',
            'total_return_including_tax_relief_percentage'
        ];
    }

    get preset_filters() {
        let filters = {};

        if (this.investor_id) {
            filters.investor_id = this.filterOperator('is') + ':' + this.investor_id;
        }

        if (this.show_consolidated_view) {
            filters.consolidated = true;
        }

        if (this.status) {
            filters.status = this.filterOperator('is') + ':OPEN';
        }

        if (this.company_id) {
            filters.company_id = this.filterOperator('is') + ':' + this.company_id;
        }

        filters.tranche_id = this.filterOperator('empty');

        return filters;
    }
}

export default HoldingSingleCompanyPanelCollection;
